import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDispatch, useSelector } from 'react-redux';
import { setAndrologyData } from '../../../../actions/andrologyAction';
import { getNestedState } from '../utils/index';

const QualityAnalysis = ({ keyPath }) => {
  const dispatch = useDispatch();
  const qualityAnalysis = useSelector((state) =>
    getNestedState(state.andrologyReducer, keyPath),
  );

  const handleChange = (key, subKey, value) => {
    dispatch(setAndrologyData(`${keyPath}.${key}.${subKey}`, value));
  };

  return (
    <Box flex={1}>
      <Paper className="p-3 mb-3">
        <Typography variant="h6" gutterBottom>
          Quality Analysis
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                  Head
                </TableCell>
                <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                  Midpiece
                </TableCell>
                <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                  Tail
                </TableCell>
                <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                  Other
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* Head Parameters */}
              <TableRow>
                <TableCell>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Tapered"
                    value={qualityAnalysis.head.tapered}
                    onChange={(e) =>
                      handleChange('head', 'tapered', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Pyriform"
                    value={qualityAnalysis.head.pyriform}
                    onChange={(e) =>
                      handleChange('head', 'pyriform', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Amorphous"
                    value={qualityAnalysis.head.amorphous}
                    onChange={(e) =>
                      handleChange('head', 'amorphous', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Round Head"
                    value={qualityAnalysis.head.roundHead}
                    onChange={(e) =>
                      handleChange('head', 'roundHead', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Macrocephalic"
                    value={qualityAnalysis.head.macrocephalic}
                    onChange={(e) =>
                      handleChange('head', 'macrocephalic', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Microcephalic"
                    value={qualityAnalysis.head.microcephalic}
                    onChange={(e) =>
                      handleChange('head', 'microcephalic', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Double Head"
                    value={qualityAnalysis.head.doubleHead}
                    onChange={(e) =>
                      handleChange('head', 'doubleHead', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <br></br>
                  <br></br>
                  {/* <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Cytoplasmic Droplet"
                    value={qualityAnalysis.head.cytoplasmicDroplet}
                    onChange={(e) =>
                      handleChange('head', 'cytoplasmicDroplet', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Vacuolated Sperm Head"
                    value={qualityAnalysis.head.vacuolatedSpermHead}
                    onChange={(e) =>
                      handleChange(
                        'head',
                        'vacuolatedSpermHead',
                        e.target.value,
                      )
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  /> */}
                </TableCell>

                {/* Midpiece Parameters */}
                <TableCell style={{ verticalAlign: 'initial' }}>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Bent Neck"
                    value={qualityAnalysis.midpiece.bentNeck}
                    onChange={(e) =>
                      handleChange('midpiece', 'bentNeck', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Asymmetrical"
                    value={qualityAnalysis.midpiece.asymmetrical}
                    onChange={(e) =>
                      handleChange('midpiece', 'asymmetrical', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Thin"
                    value={qualityAnalysis.midpiece.thin}
                    onChange={(e) =>
                      handleChange('midpiece', 'thin', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Thick"
                    value={qualityAnalysis.midpiece.thick}
                    onChange={(e) =>
                      handleChange('midpiece', 'thick', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </TableCell>

                {/* Tail Parameters */}
                <TableCell style={{ verticalAlign: 'initial' }}>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Coiled Tail"
                    value={qualityAnalysis.tail.coiledTail}
                    onChange={(e) =>
                      handleChange('tail', 'coiledTail', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Short Tail"
                    value={qualityAnalysis.tail.shortTail}
                    onChange={(e) =>
                      handleChange('tail', 'shortTail', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Double Tail"
                    value={qualityAnalysis.tail.brokenTail}
                    onChange={(e) =>
                      handleChange('tail', 'brokenTail', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </TableCell>
                <TableCell style={{ verticalAlign: 'initial' }}>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Cytoplasmic Droplet"
                    value={qualityAnalysis.head.cytoplasmicDroplet}
                    onChange={(e) =>
                      handleChange('head', 'cytoplasmicDroplet', e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <br></br>
                  <br></br>
                  <TextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="Vacuolated Sperm Head"
                    value={qualityAnalysis.head.vacuolatedSpermHead}
                    onChange={(e) =>
                      handleChange(
                        'head',
                        'vacuolatedSpermHead',
                        e.target.value,
                      )
                    }
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default QualityAnalysis;
